export default {"src":"/_next/static/media/where-is-my-vin-small.d4e604aa.svg","height":153,"width":191,"blurWidth":0,"blurHeight":0};